module.exports = __webpack_public_path__ + "static/media/what-trainers.d8dfe06f.png";